import { Message } from "element-ui";

/* 
根据文件流导出文件
*/
const exportFile = (res) => {
    console.log(res);
    // 获取当前的请求头的文件名
    const contentDisposition = res.headers["content-disposition"];
    // 如果没有，则是后台报错导出失败，处理后台抛出的异常
    console.log(contentDisposition);
    if (!contentDisposition) {
        let reader = new FileReader()
        reader.onload = (event) => {
            let content = JSON.parse(reader.result) // 错误信息
            Message({ type: "error", message: content.msg || '导出失败！' });
        }
        reader.readAsText(res.data)
        return
    }
    // 获取到请求头的文件名，进行处理
    let filename = decodeURI(
        contentDisposition.split("fileName=")[1] ||
        contentDisposition.split("filename=")[1]
    );
    filename =
        filename.indexOf('"') === -1 ?
        filename :
        filename.substring(1, filename.length - 1);
    const blob = new Blob([res.data]);
    const url = window.URL.createObjectURL(blob);
    if (window.navigator.msSaveBlob) {
        console.log('if');
        try {
            window.navigator.msSaveBlob(blob, filename);
        } catch (e) {
            console.log(e);
        }
    } else {
        console.log('else');
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
    }
};
/* 
权限判断
*/
const roleFilter = (roleName) => {
    try {
        let vuex = sessionStorage.getItem("vuex");
        let obj = JSON.parse(vuex);
        let userRole = obj.user.userRole ? obj.user.userRole : [];
        let isRole = userRole.some((item) => {
            return item == roleName;
        });
        return isRole;
    } catch (error) {
        console.log("vuex内无权限");
    }
};

export { exportFile, roleFilter };